import { DayOfWeek, OpeningHoursSpecification } from "schema-dts";

import { OpenClose, WeeklySchedule } from "@/custom-types/DispensarySchedules";
import { Weekday } from "@/custom-types/Weekday";

const DAYS_OF_WEEK: DayOfWeek[] = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export default (
  schedules: WeeklySchedule | null,
): OpeningHoursSpecification[] => {
  if (!schedules || typeof schedules !== "object") {
    return [];
  }

  return DAYS_OF_WEEK.reduce<OpeningHoursSpecification[]>((acc, day) => {
    const key = day.toString().toLowerCase() as Weekday;
    const hours: OpenClose = schedules[key]?.store || {
      close: null,
      isSpecialHours: null,
      open: null,
    };

    // Only include days that have hours with open and close times
    if (hours?.close?.time && hours?.open?.time) {
      acc.push({
        "@type": "OpeningHoursSpecification",
        closes: hours.close.time + ":00",
        dayOfWeek: day,
        opens: hours.open.time + ":00",
      });
    }
    return acc;
  }, []);
};
